import { Fragment } from 'react'
import { cn } from '@/lib/utils'

interface MentionRendererProps {
  content: string
  className?: string
}

export function MentionRenderer({ content, className }: MentionRendererProps) {
  // Parse the content to find @mentions
  const renderWithMentions = (text: string) => {
    // Regular expression to match @username patterns
    const mentionRegex = /@(\w+)/g
    const parts = []
    let lastIndex = 0
    let match

    while ((match = mentionRegex.exec(text)) !== null) {
      // Add text before the mention
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index))
      }

      // Add the mention with highlighting
      parts.push(
        <span
          key={`mention-${match.index}`}
          className="inline-flex items-center px-1.5 py-0.5 rounded-md text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 border border-blue-200 dark:border-blue-700"
        >
          @{match[1]}
        </span>
      )

      lastIndex = mentionRegex.lastIndex
    }

    // Add remaining text after the last mention
    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex))
    }

    return parts.length > 0 ? parts : [text]
  }

  const renderedContent = renderWithMentions(content)

  return (
    <span className={cn("whitespace-pre-wrap", className)}>
      {renderedContent.map((part, index) => (
        <Fragment key={index}>{part}</Fragment>
      ))}
    </span>
  )
} 